import React from 'react';
import {useSelector} from "react-redux";
import {countriesConstants, rolesConstants} from "mindsets-js-sdk";

export default function () {
    const me = useSelector(state => state.me);
    if (me && me.persona === rolesConstants.ROLE_TEACHER && me.school && me.school.country) {
        return (
            <div className="flex-row user-info-field">
                <div className="user-info-field-label">Country</div>
                <div>{countriesConstants.COUNTRIES[me.country]}</div>
            </div>
        );
    }

    return null;
}
